import React, { useState, useId, useRef } from "react";
import styled from "styled-components";
import { Cancel, FileUpload } from "../../styled/AllImages";
import { useTranslation } from "react-i18next";

const ImageUpload = ({
  name,
  UploadImage,
  onFileSelect,
  initialImage,
  setLogoDelete,
}) => {
  const fileInputRef = useRef();
  const { t } = useTranslation();
  const [selectedImage, setSelectedImage] = useState(initialImage || null);
  const uniqueId = useId();

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const fileURL = URL.createObjectURL(file); // Generate a URL for the selected image
      setSelectedImage(fileURL); // Store the image URL
      onFileSelect(file); // Emit the file to the parent
      if (setLogoDelete) setLogoDelete(0);
    }

    event.target.value = "";
  };

  const handleRemoveImage = () => {
    setSelectedImage(null);
    onFileSelect(null);
    if(setLogoDelete) setLogoDelete(1);
    fileInputRef.current.value = "";
  };

  return (
    <UploadContainer className="uploadImgContainer">
      {selectedImage ? (
        <ImagePreviewContainer>
          <ImagePreview src={selectedImage} alt="Selected" />
          <RemoveButton onClick={handleRemoveImage}>
            <Cancel />
          </RemoveButton>
        </ImagePreviewContainer>
      ) : (
        <DefaultUploadBox
          className="defaultUploadBox"
          onClick={() =>
            document.getElementById(`imageInput-${uniqueId}`).click()
          }
        >
          <FileUpload size={40} />
          <UploadText>{t(UploadImage)}</UploadText>
        </DefaultUploadBox>
      )}

      {/* Hidden file input */}
      <input
        id={`imageInput-${uniqueId}`} // Use the unique ID here
        type="file"
        ref={fileInputRef}
        name={name}
        accept="image/png, image/jpeg, image/jpg" // Accept only image files
        style={{ display: "none" }}
        onChange={handleFileChange}
      />
    </UploadContainer>
  );
};

export default ImageUpload;

const UploadContainer = styled.div`
  width: 100%;
  display: flex;
  width: 290px;
  border: 2px dashed var(--text2);
  position: relative;
  border-radius: 10px;
`;

const DefaultUploadBox = styled.div`
  display: flex;
  width: 100%;
  height: 75px;
  gap: 10px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding-left: 30px;
  padding-right: 30px;
  font-size: 14px;
  color: var(--text2);
`;

const UploadText = styled.p`
  font-size: 14px;
  margin-top: 7px;
  margin-bottom: 7px;
  color: var(--text2);
  line-height: 18px;
`;

const ImagePreviewContainer = styled.div`
  position: relative;
  width: 100%;
  height: 75px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ImagePreview = styled.img`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: 10px;
`;

const RemoveButton = styled.button`
  position: absolute;
  top: 0;
  bottom: 0;
  height: fit-content;
  right: 5px;
  margin: auto;
  background: none;
  border: none;
  cursor: pointer;
  svg {
    width: 14px;
    height: auto;
    [fill] {
      fill: var(--redColor);
    }
  }
`;
